import React from "react";
import InfoLayout, { Sec } from "@/components/InfoLayout";

export default function Terms() {
  return (
    <InfoLayout title="Terms of Use" docTitle="Terms of Use" subtitle="The rules for using CiteQR.">
      <Sec heading="Acceptable use">
        <p>You agree to use CiteQR only for lawful academic and professional purposes. You are responsible for the content you publish on reference pages and for ensuring you have the right to share it.</p>
      </Sec>
      <Sec heading="Prohibited content">
        <ul className="list-disc space-y-1 pl-5">
          <li>Malicious scripts, phishing, or harmful links.</li>
          <li>Confidential, sensitive, or identifiable patient, participant, or student data.</li>
          <li>Content that infringes intellectual property or violates the law.</li>
        </ul>
      </Sec>
      <Sec heading="No guarantees">
        <p>Static QR codes encode destinations directly and do not expire, but we cannot guarantee that external websites or documents remain online. Automated citation formatting is provided as a convenience and is not guaranteed to be academically perfect — always review before publishing.</p>
      </Sec>
      <Sec heading="Moderation">
        <p>We may unpublish content that is reported as abusive or that violates these terms, and may suspend accounts when necessary.</p>
      </Sec>
      <Sec heading="Changes">
        <p>Continued use after updates constitutes acceptance.</p>
      </Sec>
    </InfoLayout>
  );
}
